<template>
  <div class="backdrop" @click="click">
    <slot></slot>
  </div>
</template>
<script>
export default {
  methods: {
    click() {
      this.$emit("click");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../scss/global.scss";

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 500;
  overflow: auto;
}
@media (min-width: $min-width-extended) {
  .backdrop {
    overflow: hidden;
  }
}
</style>
